module.exports = "/_next/static/images/sign-moa-689378658868186b1f5b8f5c6228d4a5.svg";